var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23713 3.28845C1.84417 3.15746 1.41943 3.36983 1.28845 3.76279C1.15746 4.15575 1.36983 4.58049 1.76279 4.71147L3.6617 5.34444C4.08726 5.48629 4.40417 5.84529 4.49215 6.28515L5.94297 13.5393C6.20005 14.8247 7.32869 15.75 8.63957 15.75H18.3956C19.6845 15.75 20.8005 14.8548 21.0801 13.5965L22.7321 6.16266C22.822 5.75831 22.567 5.35768 22.1627 5.26782C21.7583 5.17796 21.3577 5.43291 21.2678 5.83726L19.6159 13.2712C19.4888 13.8431 18.9815 14.25 18.3956 14.25H8.63957C8.04372 14.25 7.5307 13.8294 7.41384 13.2451L5.96302 5.99098C5.76948 5.02329 5.07226 4.23349 4.13605 3.92142L2.23713 3.28845Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49996 20C10.3284 20 11 19.3284 11 18.5C11 17.6716 10.3284 17 9.49996 17C8.67153 17 7.99996 17.6716 7.99996 18.5C7.99996 19.3284 8.67153 20 9.49996 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5C19 19.3284 18.3284 20 17.5 20C16.6715 20 16 19.3284 16 18.5C16 17.6716 16.6715 17 17.5 17C18.3284 17 19 17.6716 19 18.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.25C13.9142 4.25 14.25 4.58579 14.25 5V8.25H16C16.291 8.25 16.5557 8.41834 16.6792 8.68188C16.8026 8.94542 16.7624 9.25658 16.5761 9.48014L14.0761 12.4801C13.9336 12.6511 13.7226 12.75 13.5 12.75C13.2774 12.75 13.0663 12.6511 12.9238 12.4801L10.4238 9.48014C10.2375 9.25658 10.1973 8.94542 10.3208 8.68188C10.4442 8.41834 10.709 8.25 11 8.25H12.75V5C12.75 4.58579 13.0858 4.25 13.5 4.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDown);
export default __webpack_public_path__ + "static/media/cart-down.09e4e6f56bf13bb9b32217d47244d667.svg";
export { ForwardRef as ReactComponent };